module.exports = __webpack_public_path__ + "static/images/pass-bg-b.fc0de4d.png";